import { Model } from '@vuex-orm/core'

export default class Settings extends Model {
  
    static entity = 'settings'
    
    static primaryKey = 'id'

    static fields () {
        return {
            id: this.increment(),
            title: this.attr(''),
            content: this.attr(''),
            key: this.attr(''),
            value:this.attr(''), 
            icon: this.attr(''),
            color: this.attr(''),
            time: this.attr(null),             
        }
    }  
}